import React, { Component } from 'react'
import AuthUserContext from '../auth/session/context';
import { Link } from 'react-router-dom';
import styles from '../css/Header.module.css';
import LogoutButton from './LogoutButton';

class Header extends Component {
    render() {

        return (
            <div className={styles.module}>
                <div className={styles.brand}>
                    <AuthUserContext.Consumer>
                        {authUser =>
                            authUser ? (
                                <h1 className={styles.logo}><Link to='/' className={styles.landingLink}>KAU: </Link> <Link to='/dashboard' className={styles.dashboardLink}>{authUser.project}</Link></h1>
                            ) : (
                                <h1 className={styles.logo}><Link to='/' className={styles.landingLink}>KAU: Measure the User Experience</Link></h1>
                            )
                        }
                    </AuthUserContext.Consumer>
                </div>
                <div className={styles.menu}>
                    <ul className={styles.menuList}>
                        <AuthUserContext.Consumer>
                            {authUser => 
                                authUser ? (
                                    <>
                                        <li><span className={styles.userEmail}>{authUser.email}</span></li>
                                        <li><Link to='/dashboard' className={styles.link}>Dashboard</Link></li>
                                        <li><LogoutButton /></li>
                                    </>
                                ) : (
                                    <Link to='/login' className={styles.link}>Login</Link>
                                )
                            }
                        </AuthUserContext.Consumer>
                    </ul>
                </div>
            </div>
        )
    }
}
export default Header;